<template>
  <div>
    <template v-for="(part, index) in parts" :key="index">
      <a v-if="part.type === 'link'" :href="part.href" target="_blank" rel="noopener noreferrer">{{ part.text }}</a>
      <template v-else>{{ part.text }}</template>
    </template>
  </div>
</template>

<script>
// 不可信的純文字（例如私訊本文）轉成可點連結；為什麼不用 v-html 見 utils/linkifyMessage.js
import { defineComponent, computed } from 'vue';
import { linkifyMessage } from '../utils/linkifyMessage';

export default defineComponent({
  props: { text: { type: String, default: null } },
  setup(props) {
    // computed 讓每則訊息只在本文變動時才重新切片，不會每次列表重繪都重跑 regex
    const parts = computed(() => linkifyMessage(props.text));

    return { parts };
  },
});
</script>
